// Type do plano retornado por GET /api/plans
// JSON é snake_case (configurado no Program.cs do backend).
export interface Plan {
  id: number;
  code: 'starter' | 'pro' | 'enterprise' | string;
  name: string;
  description?: string | null;

  // Preço da 1ª TV (taxa base do plano)
  first_tv_monthly_cents: number;
  first_tv_annual_cents: number;

  // Preço de cada TV adicional (mesmo valor em todos os planos)
  price_per_tv_monthly_cents: number;
  price_per_tv_annual_cents: number;

  // Limites (null = ilimitado)
  max_tvs: number | null;
  max_storage_mb: number;
  max_users: number | null;
  max_playlists: number | null;
  max_themes: number | null;
  max_products: number | null;
  max_stores: number | null;

  features: Record<string, boolean>;
  volume_discounts: { min_tvs: number; discount_percent: number }[];

  trial_days: number;
  is_public: boolean;
  is_active: boolean;
  sort_order: number;
}

export type BillingCycle = 'monthly' | 'annual';

/**
 * Calcula o total mensal (ou equivalente-mensal em ciclo anual) pra N TVs.
 * Total = 1ª TV (taxa base) + (N-1) × TV adicional.
 */
export function calcPlanTotalCents(plan: Plan, tvs: number, cycle: BillingCycle): number {
  const n = Math.max(1, Math.floor(tvs));
  if (cycle === 'annual') {
    // Valores anuais já vêm com 20% off aplicado no seed. Retornamos
    // o equivalente mensal pra UI mostrar comparação justa.
    const annual = plan.first_tv_annual_cents + (n - 1) * plan.price_per_tv_annual_cents;
    return Math.round(annual / 12);
  }
  return plan.first_tv_monthly_cents + (n - 1) * plan.price_per_tv_monthly_cents;
}

/** Total anual cheio (12 meses) - útil pra mostrar "cobrança anual de R$ X" */
export function calcPlanAnnualTotalCents(plan: Plan, tvs: number): number {
  const n = Math.max(1, Math.floor(tvs));
  return plan.first_tv_annual_cents + (n - 1) * plan.price_per_tv_annual_cents;
}

/** Economia anual vs pagar 12× mensal */
export function calcAnnualSavingsCents(plan: Plan, tvs: number): number {
  const n = Math.max(1, Math.floor(tvs));
  const monthly12 = (plan.first_tv_monthly_cents + (n - 1) * plan.price_per_tv_monthly_cents) * 12;
  const annual = calcPlanAnnualTotalCents(plan, n);
  return Math.max(0, monthly12 - annual);
}
